// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ykqe","label":"styles_label__3a-nK"};